function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 306,
  height: 140,
  fill: "white",
  fillOpacity: 0.9
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M71.7718 79.7843H78.3351L68.7992 69.9021H63.8235V64.9265H68.7992V69.9021H73.7749V60.02H58.9863V79.7843H63.8235V71.836L71.7718 79.7843Z",
  fill: "#002D72"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.8372 79.7852H33V60.021H57.1909V79.7852H52.3488V64.9274H47.5116V79.7852H42.6744V64.9274H37.8372V79.7852Z",
  fill: "#002D72"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M80.2593 79.7642V60H75.4072V74.7638L80.2593 79.7642Z",
  fill: "#002D72"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M186.92 63.0269H171.78V64.2584H186.92V63.0269Z",
  fill: "#002D72"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M176.849 61.5728H174.757V65.4999H176.849V61.5728Z",
  fill: "#002D72"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M184.002 61.5728H181.915V65.4999H184.002V61.5728Z",
  fill: "#002D72"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M180.549 65.124H178.269V69.0512H180.549V65.124Z",
  fill: "#002D72"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M173.392 69.6152C173.743 70.8221 172.764 73.7303 171.745 74.4277L172.541 75.1894C174.411 73.4781 175.801 71.7272 175.895 69.6746",
  fill: "#002D72"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M182.928 69.4912C182.993 73.0375 183.561 74.2394 186.984 74.7439V72.9089C185.713 72.721 185.08 71.4548 185.144 69.5506",
  fill: "#002D72"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M171.335 78.9283L172.032 79.5614C174.011 78.3546 176.593 76.0152 177.419 73.7301C178 74.776 178.749 75.7199 179.634 76.5246C179.001 77.7858 176.667 78.7998 175.455 78.9283L175.519 79.7494C177.735 79.69 180.144 78.7998 181.158 77.9144C183.245 79.2449 184.62 79.8928 186.92 79.69V77.7116C183.458 77.1379 179.318 75.7332 178.432 72.7656H181.598C181.534 73.8439 180.648 75.7332 180.267 75.8717C180.793 76.3933 181.419 76.8023 182.107 77.0736C182.8 76.0003 184.383 73.463 184.452 71.5044H175.445C175.445 71.5044 175.895 75.1249 171.335 78.9283Z",
  fill: "#002D72"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M186.92 66.1973H171.78V67.4338H186.92V66.1973Z",
  fill: "#002D72"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M186.92 68.7295H171.78V69.966H186.92V68.7295Z",
  fill: "#002D72"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M192.756 61.5083C192.627 62.5865 191.425 64.1693 191.109 64.2336L190.54 63.922L189.655 65.3118L192.301 67.4188L190.53 69.5109H190.085V71.0294H195.565L195.724 71.6031H197.178C197.056 70.4519 196.867 69.309 196.609 68.1805H194.774L195.12 69.5109H193.028L196.134 65.7421L194.611 64.7924L193.409 66.2169L192.459 65.4255C193.285 64.7924 195.15 62.2898 195.249 61.5281L192.756 61.5083Z",
  fill: "#002D72"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M200.284 69.4915H202.91L202.564 68.161H204.399C204.656 69.2896 204.846 70.4325 204.968 71.5837H203.508L203.355 71.0099H197.875V69.4915H198.572C199.176 68.6359 199.933 66.6723 199.71 65.1489H201.688C201.585 66.5437 200.852 69.175 200.284 69.4915Z",
  fill: "#002D72"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M194.26 70.7725H192.365V79.7049H194.26V70.7725Z",
  fill: "#002D72"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M190.115 73.2256V76.8411C190.115 77.4989 190.085 77.8847 189.581 77.9441L189.769 79.2103C191.035 79.1509 191.747 78.5475 191.747 76.9301V73.2256H190.115Z",
  fill: "#002D72"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M196.609 73.2603H194.868V79.7197H196.609V73.2603Z",
  fill: "#002D72"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M197.702 61.5728C197.796 62.8686 197.796 64.5849 196.624 65.3713L198.018 66.6078C199.636 65.0547 199.824 63.378 199.601 61.5728H197.702Z",
  fill: "#002D72"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M205.19 66.0984C201.728 66.321 202.089 64.6443 202.149 61.6074H203.702V63.66C203.702 64.2338 203.672 64.7086 205.185 64.6146L205.19 66.0984Z",
  fill: "#002D72"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M197.019 73.7649C197.094 75.4762 197.128 79.433 196.95 79.7001H198.597C198.754 77.707 198.765 75.7052 198.632 73.7104L197.019 73.7649Z",
  fill: "#002D72"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M199.616 72.8595L200.566 71.4351C201.402 71.8598 202.117 72.4873 202.648 73.2601L201.609 74.5906C201.195 73.7766 200.48 73.1558 199.616 72.8595Z",
  fill: "#002D72"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M202.648 74.4623L203.884 73.4731C204.78 74.1401 205.444 75.0706 205.784 76.1341L204.33 77.0194C204.018 75.9214 203.192 74.7443 202.648 74.4623Z",
  fill: "#002D72"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M201.164 74.7441H199.265V77.3111C199.265 78.3003 199.201 79.7841 201.639 79.7841H205.22V78.3003C205.22 78.3003 203.761 78.2558 202.46 78.3003C201.515 78.33 201.129 77.7315 201.129 76.7176C201.129 75.7037 201.164 74.7441 201.164 74.7441Z",
  fill: "#002D72"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M206.921 66.7961L207.49 67.7853C209.201 67.1522 213.005 65.6338 214.415 63.0372C216.126 64.9364 218.154 67.1522 220.622 67.726L221.937 66.2273C219.722 65.5299 216.002 63.1262 215.414 61.5435H212.693C211.452 63.9228 209.407 65.7843 206.921 66.7961Z",
  fill: "#002D72"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M218.446 66.6079H210.087V68.4478H218.446V66.6079Z",
  fill: "#002D72"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M208.504 79.4674V70.0947H220.409V79.4921L208.504 79.4674ZM210.824 71.5093V78.0479H218.089V71.5093H210.824Z",
  fill: "#002D72"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M230.568 62.0776H223.599V63.4675H230.568V62.0776Z",
  fill: "#002D72"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M239.303 61.9487H231.196V63.5958H239.303V61.9487Z",
  fill: "#002D72"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M223.664 79.7496V70.189H230.633V79.7496H223.664ZM228.476 78.2312V71.7074H225.815V78.2312H228.476Z",
  fill: "#002D72"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M226.641 63.1509C226.603 65.9513 225.283 68.5798 223.06 70.283L223.856 70.9161C225.276 70.4215 229.144 67.4539 229.144 63.2795",
  fill: "#002D72"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M239.303 67.6562H230.692V69.051H239.303V67.6562Z",
  fill: "#002D72"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M238.101 63.0269H236.137V79.685H238.101V63.0269Z",
  fill: "#002D72"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M232.215 63.1505V74.8379C232.215 76.3563 231.577 78.127 230.504 78.4436L231.454 79.5861C232.848 78.5969 234.05 77.5632 234.114 74.8973V63.0269",
  fill: "#002D72"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M255.486 62.5869H241.331V64.14H255.486V62.5869Z",
  fill: "#002D72"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M249.249 61.5435H246.969V63.9522H249.249V61.5435Z",
  fill: "#002D72"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M243.611 63.1904H241.331V65.5991H243.611V63.1904Z",
  fill: "#002D72"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M255.491 63.1904H253.211V65.5991H255.491V63.1904Z",
  fill: "#002D72"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M244.407 65.124C244.467 66.7958 244.185 67.6564 241.806 68.794L242.567 69.6743C245.07 69.0462 246.371 67.7504 246.875 65.1488L244.407 65.124Z",
  fill: "#002D72"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M249.947 65.124H251.846C251.846 66.3853 251.881 67.6861 253.463 67.6861H255.486V69.5853H252.603C251.559 69.5853 249.912 68.7297 249.912 67.2755C249.912 65.8214 249.947 65.124 249.947 65.124Z",
  fill: "#002D72"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M252.89 70.728H241.84V71.8013H252.89V70.728Z",
  fill: "#002D72"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M252.889 71.7075V76.0797C252.889 77.0294 252.766 77.5982 255.427 77.341V79.2452H252.108C250.995 79.2452 250.426 78.0433 250.426 77.0294V71.6729",
  fill: "#002D72"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M245.51 69.1752V72.0884C245.51 75.056 244.372 77.8851 241.301 78.5775L242.028 79.7497C244.847 78.7061 247.963 77.1877 247.963 72.2467V69.1455L245.51 69.1752Z",
  fill: "#002D72"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M153.326 67.7062V66.1729H150.126V61.5435H147.975V66.1729H145.081V67.7062H147.975V78.167H144.537V79.7052H153.326V78.167H150.126V67.7062H153.326Z",
  fill: "#002D72"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M142.876 69.798C143.555 68.6102 144.098 67.3492 144.493 66.039V64.5008H142.139V61.5332H139.987V64.5008H137.395V66.039H142.119C141.416 69.3974 139.235 72.365 136.95 74.3434L137.559 75.1743C138.442 74.7253 139.259 74.1561 139.987 73.4828V79.7048H142.139V71.9594C143.209 72.7864 144.162 73.7547 144.973 74.838L145.66 74.0763C144.87 72.5652 143.937 71.1327 142.876 69.798Z",
  fill: "#002D72"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M119.501 62.9921C118.963 62.288 118.271 61.7162 117.478 61.3203L116.454 62.5469C117.195 62.8941 117.819 63.4492 118.25 64.1445L119.501 62.9921Z",
  fill: "#002D72"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M118.754 78.2412C117.997 78.0433 117.131 77.3905 116.889 75.6742C116.493 72.8204 116.177 69.19 115.959 65.7426H119.501V64.2094H115.87C115.816 63.2894 115.771 62.3942 115.737 61.5435H113.368C113.427 62.3744 113.481 63.2696 113.536 64.2094H104.475V65.7426H113.62C113.842 69.556 114.114 73.765 114.728 76.7574C115.123 78.6913 116.474 79.725 118.447 79.725H119.555V78.2412C119.294 78.3229 119.014 78.3229 118.754 78.2412Z",
  fill: "#002D72"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M113.358 77.2713C112.502 77.6324 112.022 77.8203 109.747 77.9093V69.9957H112.898V68.4575H104.761V69.9908H107.596V77.9539C106.725 77.9539 105.701 77.9539 104.475 77.9539V79.685C111.701 79.685 112.883 79.1063 113.709 78.4089L113.358 77.2713Z",
  fill: "#002D72"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M135.674 66.2224C133.458 65.5299 129.739 63.1262 129.15 61.5435H126.425C125.191 63.924 123.147 65.7864 120.663 66.7961L121.232 67.7853C122.122 67.4641 122.992 67.0908 123.838 66.6675V68.2502H132.192V66.7664C132.852 67.1979 133.579 67.5156 134.344 67.7062L135.674 66.2224ZM124.007 66.6082C125.604 65.7822 127.301 64.6298 128.136 63.0619C129.246 64.3833 130.505 65.5732 131.886 66.6082H124.007Z",
  fill: "#002D72"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M135.199 79.7048C135.056 76.7966 131.826 73.8537 130.936 73.275L130.169 73.9872C131.11 74.9012 131.843 76.0058 132.321 77.2269C131.208 77.6868 129.591 77.8946 124.407 77.944C126.275 76.3342 127.47 74.0819 127.756 71.6329H134.942V69.981H121.425V71.6478H125.154C125.051 74.0297 124.059 76.2864 122.374 77.9737H121.425V79.7048C129.981 79.7048 131.846 79.0964 132.687 78.404C132.784 78.8315 132.844 79.2668 132.865 79.7048H135.199Z",
  fill: "#002D72"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M102.769 75.9363C101.018 74.4229 99.168 72.1922 98.3173 70.1446V69.9863H102.032V68.4481H98.3173V65.7426H101.75V64.2044H98.3272V61.5435H96.2895V64.2044H94.8749C95.1534 63.3423 95.3195 62.448 95.3695 61.5435H93.3218C93.4406 62.9679 92.7481 66.6626 91.7342 67.36L92.5255 68.1216C93.2462 67.4416 93.8362 66.6353 94.2665 65.7426H96.2944V68.4481H92.8322V69.9863H96.0768C95.2607 72.9539 93.2378 75.7632 91.4819 77.0986L92.0557 78.167C93.7472 77.1343 95.1964 75.7493 96.3043 74.1063V79.7052H98.342V73.2754C99.214 75.0472 100.361 76.6698 101.74 78.0829L102.769 75.9363Z",
  fill: "#002D72"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M93.2125 71.3758C91.8954 69.853 90.9834 68.0226 90.5615 66.0539H91.981V64.5008H90.5516V61.5332H88.5188V64.5008H86.2832V66.0341H88.499C88.3753 69.1797 86.1595 73.6361 85.4819 74.3928L86.2832 75.1644C87.1255 74.2218 87.8738 73.1998 88.5188 72.1127V79.7048H90.5516V70.2085C90.9403 71.1567 91.4384 72.0563 92.0354 72.8892L93.2125 71.3758Z",
  fill: "#002D72"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M264.834 62.1465H258.058V63.5363H264.834V62.1465Z",
  fill: "#002D72"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M260.21 66.0688H258.058V79.6901H260.21V66.0688Z",
  fill: "#002D72"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M258.043 72.1524V66.0688H264.879V72.1524H258.043ZM262.594 70.817V67.4191H260.324V70.8269L262.594 70.817Z",
  fill: "#002D72"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M271.288 61.3203C269.617 62.3879 267.695 62.9985 265.714 63.091V71.2024C265.714 73.7991 265.714 76.9645 264.072 78.5473L264.765 79.3089C266.664 77.4097 268.123 76.1435 268.123 71.2024V63.9813C269.518 63.912 272.238 63.2789 273 62.7794L271.288 61.3203Z",
  fill: "#002D72"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M272.683 67.147H265.907V68.5417H272.683V67.147Z",
  fill: "#002D72"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M272.302 68.2896H270.151V79.6901H272.302V68.2896Z",
  fill: "#002D72"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M168.614 62.4087H155.948V64.5651H168.614V62.4087Z",
  fill: "#002D72"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M167.665 69.2539H156.897V71.4054H167.665V69.2539Z",
  fill: "#002D72"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M169.06 77.5483H155.503V79.6999H169.06V77.5483Z",
  fill: "#002D72"
});

var _ref63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -4,
  y: -4,
  width: 314,
  height: 148,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})));

function SvgLogoMri(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 140,
    viewBox: "0 0 306 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMri);
export default __webpack_public_path__ + "static/media/logo_mri.145ef1e6.svg";
export { ForwardRef as ReactComponent };